import { apiFetch } from './apiFetch';
import type { Receipt, DateField } from '@deposits/shared';

export interface ListPendingParams {
  dateField: DateField;
  from: string; // YYYY-MM-DD
  to: string; // YYYY-MM-DD
  locationId: number;
  /** Omitted when the box doesn't manage projects. */
  projectId: number | null;
}

export async function fetchPendingReceipts(p: ListPendingParams): Promise<Receipt[]> {
  const qs = new URLSearchParams({
    dateField: p.dateField,
    from: p.from,
    to: p.to,
    location_id: String(p.locationId),
  });
  if (p.projectId != null) qs.set('project_id', String(p.projectId));
  return apiFetch<Receipt[]>(`/receipts/pending?${qs.toString()}`);
}
